import axios from "../utils/axios";

export const getTestimonialSection = async () => {
    const response = await axios.get("/testimonial-section");
    return response.data;
};

export const updateTestimonialSection = async (data) => {
    const response = await axios.put("/testimonial-section", data);
    return response.data;
};
